import { useEffect } from 'react';
import { publish } from '@jutro/events';
import { ADOBE_TOPICS } from 'sg-adobe-analytics';

function useSgTrackPageName(pageName) {
    useEffect(() => {
        if (pageName) {
            publish(ADOBE_TOPICS.PAGE_NAME, {
                pageName: pageName
            });
        }
    }, [pageName]);
}

export default useSgTrackPageName;
